import React from "react";
import AddEvents from "../../Administrative/AddEvents";

const AddYuvasarthiEvents = () => {
  return (
    <div>
      <AddEvents role="Super Admin" />
    </div>
  );
};

export default AddYuvasarthiEvents;
